module.exports = __webpack_public_path__ + "public/images/Illustration_Shapes_200x200-Color.7984ab86ffdc3f3df4a079bf70683a24.png";